// ヘッダーの固定エフェクト // Fixed header effect
jQuery(function($) {
	var $header = $('header');
	$(window).scroll(function() {
		if ($(window).scrollTop() > 70) {
			$header.addClass('scrolling');
		} else {
			$header.removeClass('scrolling');
		}
	});
});